<template>
  <div class="questions">
    <div class="header"></div>
    <div class="questionList">
      <div class="item" v-for="(qa, index) in questionList" :key="index">
        <div class="item-title">
          <div class="item-qicon">Q</div>
          <div class="item-name">{{ qa.title }}</div>
        </div>
        <div class="item-body">
          <div class="item-aicon">A</div>
          <div class="item-content" v-html="qa.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Questions",
  components: {},
  props: {},
  computed: {},
  data: function() {
    return {
      questionList: [
        {
          title: "你們的產品是正品嗎？",
          content: `我們保證正品。我們獲得VISUFARMA大中华区授权，所有包裹均向海关进行申报并接受海关监管，保證合規清關進口。`
        },
        {
          title: "COQUN 含有防腐剂吗？",
          content: `不含`
        },
        {
          title: "COQUN 适合戴隐形眼镜吗？",
          content: `是的，佩戴隐形眼镜时可以使用 COQUN`
        },
        {
          title: "使用时有哪些必须遵循的说明？",
          content: `应在服用其他药物后至少 10 分钟滴注 COQUN`
        },
        {
          title: "维生素E在COQUN中起什么作用？",
          content: `辅酶 Q10 是一种亲脂性分子。因此，它不能放入溶液中。在 COQUN 中，维生素 E 
        TPGS 被用作载体，它形成胶束复合物，使 CoQ10 能够留在溶液中（在瓶中），也
        能到达眼睛的各个结构（亲脂性分子倾向于留在泪膜的脂质层中）。在 COQUN 的
        背景下，我们不能声称维生素 E 有任何作用，只能说它是一种载体。`
        },
        {
          title: "COQUN 含有磷酸盐吗？",
          content: `(1)是的，存在磷酸盐缓冲液。(2)然而，由于存在EDTA（一种螯合剂），可以假设在没有Ca2+的情况下，磷酸盐不
        会沉淀并诱导钙化。`
        },
        {
          title: "關於身份證上傳問題",
          content: `此商品為跨境直郵處方商品，根據海關相關規定需核驗收件人身份信息等，
          如收貨人非真實姓名、非真實手機號碼，會導致商品無法發貨，因此您在下單購買時，
          請準確填寫真實姓名、真實手機號碼與對應身份證件，以備海關檢查。如有疑問，請咨詢客服。`
        },
        {
          title: "關於時效",
          content: `香港直郵產品下單付款後，正常情況下7-15個工作日可以到貨（偏遠地區除外），如遇週末
          、節假日及惡劣天氣，發貨及清關時效會有所延遲。屆時還請您耐心等待。`
        },
        {
          title: "關於稅務",
          content: `您購買的產品均由買方承擔海關稅務，如遇特殊情況請與客服聯繫。`
        },
        {
          title: "關於發票",
          content: `海外直郵商品无法提供发票`
        },
        {
          title: "支持7天無理由退換貨嗎？",
          content: `該產品為藥品且經海關登記進口，<span style="color:red">不支持七天無理由退換貨</span>
          ，故海外直郵商品<span style="color:red">非質量問題不支持退換貨等相關服務。</span>`
        }
      ]
    };
  },
  created() {},
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.questions {
  padding: 0.3rem;
  background-color: rgb(245, 250, 254);
  .header {
    background-image: url("../../../assets/moblie/images/questionheader.png");
    background-size: 100% 100%;
    width: 100%;
    height: 2.5rem;
    margin-bottom: 0.3rem;
  }
  .questionList {
    .item {
      background-color: #fff;
      border-radius: 10px;
      padding: 0.2rem;
      margin-bottom: 0.3rem;
      &-title,
      &-body {
        display: flex;
        align-items: flex-start;
      }
      &-title {
        margin-bottom: 0.2rem;
        padding-bottom: 0.2rem;
        border-bottom: 1px dotted rgb(207, 207, 207);
      }
      &-name {
        font-weight: 700;
        font-size: 0.3rem;
      }
      &-content {
        color: rgb(81, 81, 81);
        font-size: 0.3rem;
      }
      &-qicon {
        color: #fff;
        padding: 0.03rem 0.07rem;
        font-weight: 700;
        font-size: 0.3rem;
        box-sizing: border-box;
        margin-right: 0.2rem;
        border-radius: 4px;

        background-color: rgb(108, 139, 221);
      }
      &-aicon {
        color: #fff;
        padding: 0.03rem 0.07rem;
        font-weight: 700;
        font-size: 0.3rem;
        box-sizing: border-box;
        margin-right: 0.2rem;
        border-radius: 4px;

        background-color: rgb(204, 204, 204);
      }
    }
  }
}
</style>
